
import {
  BlockText,
} from 'src/implementations';


const mappers = {
  text: BlockText,
};

export default mappers;

